import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { AppLoadService, IBlob } from '@ebb-v2/ebb-integration';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BlobApiService {
  public uriEbb: string;
  private headerContentType = new HttpHeaders({ Accept: 'application/json' });
  private pdfContentType = new HttpHeaders({ Accept: 'application/pdf' });
  public  taskfileurl: string;
  constructor(
    private http: HttpClient,
    private readonly apiAppSettings: AppLoadService
  ) {
    if (window['ebbApi']) {
      this.uriEbb = `${window['ebbApi']}/File`;
    } else {
      this.uriEbb = `https://${environment.devBaseUrl}/File`;
    }
    const envSettings = this.apiAppSettings.readEnvironSettings();

    this.taskfileurl = `${envSettings.uriApiRoot}/files`;
  }
  // photos permit =1 ,bid =2,inspection =3
  public getTaskFiles(
    fileGuidString: string,
    fileName: string,
    filetype:number
  ): Observable<Blob> {


    let url = '';
    //fileName= fileName.replace(/[;,/?:@&=+$]/g, '');

    if (filetype === 1) {
      url = ` ${this.taskfileurl}/annotationApprovalTask/${encodeURIComponent(fileGuidString)}/${encodeURIComponent(fileName)}`;
    } else if (filetype === 2) {
      url = ` ${this.taskfileurl}/annotationbid/${encodeURIComponent(fileGuidString)}/${encodeURIComponent(fileName)}`;
    } else if (filetype === 3) {
      url = ` ${this.taskfileurl}/annotationinspection/${encodeURIComponent(fileGuidString)}/${encodeURIComponent(fileName)}`;
    }
    console.debug(`GET Annotation Approval Task ${url}`);
    var getFile = this.http.get(url, {
      headers: { 'Access-Control-Allow-Origin': '*' },
      withCredentials: true,
      responseType: 'blob'
    });
    return getFile;
  }


  public postFile(blob: IBlob): Observable<any> {
    console.log(`POST ${this.uriEbb}/${blob.fileId}`);
    const formData = new FormData();
    formData.append('file', blob.file);
    return this.http
      .post<any>(
        `${this.uriEbb}?id=${blob.id}&fileId=${blob.fileId}`,
        formData,
        {
          headers: { 'Access-Control-Allow-Origin': '*' },
          withCredentials: true
        }
      )
      .pipe(
        map((response: Response) => response),
        catchError(err => of(err))
      );
  }
}
